'use strict'
const Leadership = {
    init: function () {
        Leadership.blocs = document.querySelectorAll(".f-experts")
        Leadership.paliers = [1000, 800, 300, 0];
        Leadership.currentPalier = -1;

        if (Leadership.blocs.length > 0) {
            setTimeout(() => {
                Leadership.resize();
            }, 100)
            window.addEventListener("resize", () => Leadership.resize())
        }
    },

    resize: function () {
        if (Leadership.blocs.length > 0) {

            let currentWidth = window.innerWidth;
            let currentPalier = 0;
            for (let i = 0; i < Leadership.paliers; i++) {
                if (currentWidth > Leadership.paliers[i]) {
                    currentPalier = Leadership.paliers[i];
                    break;
                }
            }

            if (true || Leadership.currentPalier !== currentPalier) {
                Leadership.currentPalier = currentPalier;

                Leadership.blocs.forEach(bloc => {
                    const items = bloc.querySelectorAll(".f-experts__content > ul > li");
                    let heightMax = 0;
                    let currentTop = -1;
                    let blocToChange = [];

                    for (let i = 0; i < items.length; i++) {
                        let title = items[i].querySelector(".c-card__title");
                        title.style.height = "";
                        let height = title.clientHeight;
                        let offsetTop = title.offsetTop;

                        if (currentTop !== offsetTop) {

                            if (currentTop !== -1) {
                                blocToChange.forEach(b => b.style.height = (currentWidth >= 768 ? heightMax + "px" : "auto"));
                                offsetTop = title.offsetTop;
                            }

                            currentTop = offsetTop;
                            heightMax = 0;
                            blocToChange = [];
                        }

                        if (heightMax < height) {
                            heightMax = height;
                        }

                        blocToChange.push(title);
                    }

                    blocToChange.forEach(b => b.style.height = heightMax + "px");
                });
            }

        }
    }
}

export default Leadership;
